// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.terms-list {\n\tfont-size: 14.5px;\n\tline-height: 2;\n}\n.terms-list ol {\n  margin-left: 20px;\n}\n.terms-list li {\n  line-height: 2;\n}\n.sub-list {\n  list-style-type: lower-roman; /* i, ii, iii... */\n  margin-top: 12px;\n  margin-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
